<template>
  <div>
    <p>
      <span v-if="item.matchType != null">{{ item.matchType.name }}</span>
      <!-- <span v-if="item.league != null">( {{item.league.name}} )</span> -->
    </p>
    <div class="table">
      <div>
        <div
          class="img"
          :style="'background-image: url(' + item.firstTeam.logoUrl + ')'"
        ></div>
        <h6>{{ item.firstTeam.name }}</h6>
      </div>
      <div class="score">
        <p class="only-score" v-if="dateCheck == false">
          {{ item.firstTeamScore }} : {{ item.secondTeamScore }}
        </p>
        <p v-else>
          <span v-if="item.isTbd == false">{{ dateCheck }}</span>
          <span v-else>TBD</span>
        </p>
      </div>
      <div>
        <div
          class="img"
          :style="'background-image: url(' + item.secondTeam.logoUrl + ')'"
        ></div>
        <h6>{{ item.secondTeam.name }}</h6>
      </div>
    </div>
    <a
      class="stadium"
      v-if="item.stadium != null"
      :href="item.stadium.locationUrl"
      target="_blank"
      >{{ item.stadium.name }}</a
    >
    <a v-else class="stadium"></a>
    <h5>{{ allDate }}</h5>
    <slot />
    <div class="video-line">
      <div class="video-link" v-if="item.video != null">
        <video-btn :btnType="'match'" :videoLink="item.video"></video-btn>
      </div>
      <div class="video-link" v-if="item.streamUrl != null">
        <div>
          <a
            target="_blank"
            :href="item.streamUrl"
            class="btn btn_icon btn-blue"
          >
            <span class="text" v-if="item.time == 'future'"
              >watch the game</span
            >
            <span class="text" v-else-if="item.time == 'past'">full game</span>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import moment from "moment";
import NewsVideo from "@/components/shared/Video-btn";
export default {
  props: {
    item: Object,
  },
  data() {
    return {};
  },
  computed: {
    dateCheck() {
      var date = this.item.eventDate;
      if (moment().isAfter(date, "day")) {
        return false;
      } else {
        return moment(this.item.eventDate).utc().format("h : mm A");
      }
      /*.format("h : mm A Z");*/
    },
    allDate() {
      var date = this.item.eventDate;
      return moment(date).utc().format("MM.DD.YY");
    },
  },
  components: {
    "video-btn": NewsVideo,
  },
};
</script>
<style lang="scss" scoped>
.moments {
  display: none;
}
p {
  font-size: 1.2rem;
  color: #000;
  font-weight: 400;
  text-align: center;
}
h6,
.stadium {
  display: inline-block;
  font-size: 1.1rem;
  color: #565656;
  text-align: center;
  font-weight: 400;
  line-height: 2rem;
  text-transform: uppercase;
  letter-spacing: 1px;
  margin: 0 auto;
  transition: all 0.3s ease;
  &[href]:hover {
    color: $blue;
    font-weight: 500;
  }
}
h5 {
  color: #1b1b1b;
  font-size: 1.3rem;
  line-height: 2rem;
  font-weight: 700;
  text-align: center;
  margin-bottom: 3rem;
  letter-spacing: 1px;
}
.table {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  margin-bottom: 1.5rem;
  & > div {
    width: 50%;
    &.score {
      width: 13rem;
      @media only screen and (max-width: 768px) {
        width: 9.5rem;
      }
    }
  }
  .img {
    height: 8rem;
    width: 90%;
    background-size: contain;
    background-position: center center;
    background-repeat: no-repeat;
    margin: 0 auto 2rem;
  }
  h6 {
    width: 100%;
    font-size: 1.4rem;
    line-height: 1.1;
    font-weight: 700;
    text-align: center;
    text-transform: capitalize;
    color: #363636;
    letter-spacing: inherit;
    min-height: 4rem;
  }
}
.video-link {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
}
.score {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  height: 8rem;
  p {
    font-size: 1.8rem;
    line-height: 1;
    font-weight: 700;
    color: #393939;
  }
}
.white {
  padding: 0 5rem 0;
  @media only screen and (max-width: 1199px) {
    padding: 0 3rem 0;
  }
  @media only screen and (max-width: 992px) {
    padding: 0;
  }
  .moments {
    display: block;
    columns: 2;
    padding: 0 12rem;
    @media only screen and (max-width: 1199px) {
      padding: 0 7rem;
    }
    @media only screen and (max-width: 768px) {
      padding: 0;
    }
    @media only screen and (max-width: 599px) {
      display: none;
    }
    h5 {
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-align: center;
      -ms-flex-align: center;
      align-items: center;
      //width: 45%;
      margin-bottom: 3rem;
      padding-left: 2rem;
      @media only screen and (max-width: 1399px) {
        margin-bottom: 2rem;
      }
      @media only screen and (max-width: 992px) {
        margin-bottom: 1rem;
      }
      &.end {
        display: none;
      }
    }
  }
  & * {
    color: #fff !important;
  }
  p {
    font-size: 1.5rem;
    margin-bottom: 1.5rem;
    @media only screen and (max-width: 1399px) {
      margin-bottom: 0;
    }
  }
  h6,
  h5,
  .stadium {
    font-size: 1.5rem;
    line-height: 3rem;
    margin-bottom: 0;
    font-weight: 400;
    @media only screen and (max-width: 992px) {
      line-height: 2.5rem;
    }
  }
  h5 {
    margin-bottom: 1rem;
  }
  .table {
    margin-bottom: 0;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    .img {
      width: 20rem;
      height: 12rem;
      @media only screen and (max-width: 1499px) {
        width: 18rem;
        height: 10rem;
      }
      @media only screen and (max-width: 599px) {
        width: 9rem;
        height: 8rem;
      }
    }
    h6 {
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-align: center;
      -ms-flex-align: center;
      align-items: center;
      font-size: 2.6rem;
      font-weight: 700;
      line-height: auto;
      padding: 1.5rem;
      @media only screen and (max-width: 1199px) {
        font-size: 2.2rem;
      }
      @media only screen and (max-width: 992px) {
        font-size: 2rem;
        padding: 1rem;
      }
      @media only screen and (max-width: 599px) {
        font-size: 1.5rem;
      }
    }
    & > div {
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-pack: justify;
      -ms-flex-pack: justify;
      justify-content: space-between;
      &:first-of-type {
        @media only screen and (max-width: 768px) {
          -webkit-box-orient: vertical;
          -webkit-box-direction: normal;
          -ms-flex-direction: column;
          flex-direction: column;
          -webkit-box-align: center;
          -ms-flex-align: center;
          align-items: center;
        }
        h6 {
          padding-right: 3rem;
          text-align: right;
          @media only screen and (max-width: 1199px) {
            padding-right: 1.5rem;
          }
          @media only screen and (max-width: 599px) {
            text-align: center;
          }
        }
      }
      &:last-of-type {
        -webkit-box-orient: horizontal;
        -webkit-box-direction: reverse;
        -ms-flex-direction: row-reverse;
        flex-direction: row-reverse;
        @media only screen and (max-width: 768px) {
          -webkit-box-orient: vertical;
          -webkit-box-direction: normal;
          -ms-flex-direction: column;
          flex-direction: column;
          -webkit-box-align: center;
          -ms-flex-align: center;
          align-items: center;
        }
        h6 {
          padding-left: 3rem;
          text-align: left;
          @media only screen and (max-width: 1199px) {
            padding-left: 1.5rem;
          }
          @media only screen and (max-width: 599px) {
            text-align: center;
          }
        }
      }
      &.score {
        //min-width: 23rem;
        width: auto;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        justify-content: center;
        @media only screen and (max-width: 992px) {
          //min-width: 18rem;
        }
        @media only screen and (max-width: 768px) {
          //min-width: 13rem;
        }
        @media only screen and (max-width: 599px) {
          //min-width: 10rem;
        }
        p {
          font-size: 6rem;
          line-height: 6rem;
          margin-bottom: 0;
          white-space: nowrap;
          padding: 0 1rem;
          @media only screen and (max-width: 992px) {
            font-size: 5rem;
            line-height: 5rem;
          }
          @media only screen and (max-width: 768px) {
            font-size: 4rem;
            line-height: 4rem;
          }
          @media only screen and (max-width: 599px) {
            font-size: 2.5rem;
            line-height: 1.6;
          }
        }
      }
    }
    img {
      height: 12rem;
      margin: 0;
      @media only screen and (max-width: 1199px) {
        height: 10rem;
      }
      @media only screen and (max-width: 992px) {
        height: 8rem;
      }
      @media only screen and (max-width: 599px) {
        height: 6rem;
      }
    }
  }
  .video-line {
    margin-bottom: 4rem;
    @media only screen and (max-width: 1199px) {
      margin-top: 2rem;
    }
  }
  .video-link {
    margin-top: 4rem;
    @media only screen and (max-width: 1399px) {
      margin-top: 2rem;
    }
    @media only screen and (max-width: 599px) {
      margin-top: 1rem;
    }
  }
}

span {
  &.icon {
    display: inline-block;
    width: 2rem;
    height: 2rem;
    margin-right: 2rem;
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
  }
}
.only-score {
  letter-spacing: 3px;
}
@keyframes scale {
  0% {
    opacity: 0.5;
    transform: scale(0, 0);
  }
  50% {
    opacity: 1;
    transform: scale(1.05, 1.05);
  }
  100% {
    opacity: 1;
    transform: scale(1, 1);
  }
}

.match {
  & > p {
    height: 3rem;
  }
  & > h6 {
    height: 2rem;
  }
}
</style>